import { Component, ElementRef, HostListener, Input, Renderer2, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AppComponent } from 'src/app/app.component';
import { Blog } from 'src/app/classes/interfaces/blog.interface';
import { Utils } from 'src/app/classes/utils';
import { environment } from 'src/environments/environment.dev';

class BlogModel implements Blog {
  createDate: string = '';
  isRTL: boolean = false;
  id: number = 0;
  title: string = '';
  updateDate: string = '';
  updatedByFirstName: string = '';
  updatedByLastName: string = '';
  cardImagePath: string = '';
  viewsCount: number = 0;
  authorIconPath: string = '';
  studyTime: string = '';
  publishDate: string = '';
  browserTitle: string = '';
  brief: string = '';
  favoriteCount: number = 0;
  colorCode: string;
  commentCount : string;
  altImage : string = '';
}

@Component({
  selector: 'app-blog-cart',
  templateUrl: './blog-cart.component.html',
  styleUrls: ['./blog-cart.component.scss'],
})
export class BlogCartComponent {
  @ViewChild('divider', { static: true }) divider!: ElementRef;
  @ViewChild('boxCard', { static: true }) boxCard!: ElementRef;
  @ViewChild('briefCard', { static: true }) briefCard!: ElementRef; 
  
  link: string = '';
  loading: boolean = true;

  contentUrl = environment.contentUrl;
  url = '';
  @Input('data') item: Blog = new BlogModel();

  constructor(
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object
  ){}

  device: 'sm' | 'lg' = 'lg';
  ngOnInit() {
    this.loading = false;
    this.getUrl();
    if (this.item.studyTime == null || undefined) {
      this.item.studyTime = '00:15:00';
    }
  }
  getUrl() {
    let language = this.item.isRTL ? 'fa' : 'en';
    this.link = 'https://www.iraniexpert.com/articles/';
    this.url = this.item.browserTitle.split(' ').join('_') + '/' + language;
  }
  
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.updateDeviceValue();
  }
  
  updateDeviceValue() {
    if (isPlatformBrowser(this.platformId)) {
      if (Utils.isMobileL()) {
        this.device = 'sm';
      } else {
        this.device = 'lg';
      }
    }
  }

  like(value: boolean) {
    if (value) this.item.favoriteCount += 1;
    else this.item.favoriteCount -= 1;
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.renderer.listen(this.boxCard.nativeElement, 'mouseenter', () => {
        this.renderer.addClass(this.divider.nativeElement, 'animate');
        this.renderer.addClass(this.briefCard.nativeElement, 'show');
      });

      this.renderer.listen(this.boxCard.nativeElement, 'mouseleave', () => {
        this.renderer.removeClass(this.divider.nativeElement, 'animate');
        this.renderer.removeClass(this.briefCard.nativeElement, 'show');
      });
    }
  }
}